import { Component, OnInit } from "@angular/core";
import {
  BRAND_CLIENT_SERVICE_NUMBER,
  BRAND_ROAD_SIDE_NUMBER,
} from "src/app/authentication/model/auth.enum";
import { ApiSearchUtilService } from "src/app/shared/service/api-search-util/api-search-util.service";
import { ProfileManagementService } from "src/app/shared/service/store-management/profile-management/profile-management.service";
import { environment } from "src/environments/environment";
import { SubFooterComponent } from "./sub-footer/sub-footer.component";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { CommonModule } from "@angular/common";

@Component({
    selector: "ald-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    imports: [
        SubFooterComponent,
        I18nPipe,
        CommonModule
    ]
})
export class FooterComponent implements OnInit {
  constructor(
    private profileManagementService: ProfileManagementService,
    private apiSearchUtilService: ApiSearchUtilService
  ) {}
  clientServiceTelephone = "";
  roadsideAssistanceTelephone = "";
  basePath = window.location.hostname;
  isSmart = this.apiSearchUtilService.findTerm(this.basePath, "smart");
  isLynkCo = this.apiSearchUtilService.findTerm(this.basePath, "lynkco");
  isAld = this.apiSearchUtilService.findTerm(this.basePath, "ald");
  ngOnInit() {}

  checkIfRicaricar(profile): boolean {
    return profile.role == "7" || profile.role == "5";
  }

  getClientServiceTelephoneStartingFromCaptive(): BRAND_CLIENT_SERVICE_NUMBER {
    switch (this.basePath) {
      case this.apiSearchUtilService.findTerm(this.basePath, "fordfleetmanagement"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.FFM;
        return BRAND_CLIENT_SERVICE_NUMBER.FFM;
      case this.apiSearchUtilService.findTerm(this.basePath, "ford"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.FORD;
        return BRAND_CLIENT_SERVICE_NUMBER.FORD;
      case this.apiSearchUtilService.findTerm(this.basePath, "honda"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.HONDA;
        return BRAND_CLIENT_SERVICE_NUMBER.HONDA;
      case this.apiSearchUtilService.findTerm(this.basePath, "suzuki"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.SUZUKI;
        return BRAND_CLIENT_SERVICE_NUMBER.SUZUKI;
      case this.apiSearchUtilService.findTerm(this.basePath, "landrover"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.LAND_ROVER;
        return BRAND_CLIENT_SERVICE_NUMBER.LAND_ROVER;
      case this.apiSearchUtilService.findTerm(this.basePath, "jaguar"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.JAGUAR;
        return BRAND_CLIENT_SERVICE_NUMBER.JAGUAR;
        case this.apiSearchUtilService.findTerm(this.basePath, "smart"):
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.SMART;
        return BRAND_CLIENT_SERVICE_NUMBER.SMART;
        case this.apiSearchUtilService.findTerm(this.basePath, "lynkco"):
          this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.LYNKCO;
          return BRAND_CLIENT_SERVICE_NUMBER.LYNKCO;
        case this.apiSearchUtilService.findTerm(this.basePath, "omodajaecoo"):
          this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.OMODA_JAECOO;
          return BRAND_CLIENT_SERVICE_NUMBER.OMODA_JAECOO;
        case this.apiSearchUtilService.findTerm(this.basePath, "mg"):
          this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.MG;
          return BRAND_CLIENT_SERVICE_NUMBER.MG;
      default:
        //return this.defaultClientServiceTelephoneRole();
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.MY_ALD;
        return BRAND_CLIENT_SERVICE_NUMBER.MY_ALD;
    }
  }

  defaultClientServiceTelephoneRole():
    | BRAND_CLIENT_SERVICE_NUMBER.MY_ALD
    | BRAND_CLIENT_SERVICE_NUMBER.RICARICAR {
    const profile = this.profileManagementService.getProfileByStore();
    if (!!profile) {
      if (this.checkIfRicaricar(profile)) {
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.RICARICAR;
        return BRAND_CLIENT_SERVICE_NUMBER.RICARICAR;
      } else {
        this.clientServiceTelephone = BRAND_CLIENT_SERVICE_NUMBER.MY_ALD;
        return BRAND_CLIENT_SERVICE_NUMBER.MY_ALD;
      }
    }
  }

  getRoadsideAssistanceTelephoneStartingFromCaptive(): BRAND_ROAD_SIDE_NUMBER {
    switch (this.basePath) {
      case this.apiSearchUtilService.findTerm(this.basePath, "fordfleetmanagement"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.FFM;
        return BRAND_ROAD_SIDE_NUMBER.FFM;
      case this.apiSearchUtilService.findTerm(this.basePath, "ford"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.FORD;
        return BRAND_ROAD_SIDE_NUMBER.FORD;
      case this.apiSearchUtilService.findTerm(this.basePath, "honda"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.HONDA;
        return BRAND_ROAD_SIDE_NUMBER.HONDA;
      case this.apiSearchUtilService.findTerm(this.basePath, "suzuki"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.SUZUKI;
        return BRAND_ROAD_SIDE_NUMBER.SUZUKI;
      case this.apiSearchUtilService.findTerm(this.basePath, "landrover"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.LAND_ROVER;
        return BRAND_ROAD_SIDE_NUMBER.LAND_ROVER;
      case this.apiSearchUtilService.findTerm(this.basePath, "jaguar"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.JAGUAR;
        return BRAND_ROAD_SIDE_NUMBER.JAGUAR;
      case this.apiSearchUtilService.findTerm(this.basePath, "omodajaecoo"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.OMODA_JAECOO;
        return BRAND_ROAD_SIDE_NUMBER.OMODA_JAECOO;
      case this.apiSearchUtilService.findTerm(this.basePath, "mg"):
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.MG;
        return BRAND_ROAD_SIDE_NUMBER.MG;
      default:
        this.roadsideAssistanceTelephone = BRAND_ROAD_SIDE_NUMBER.MY_ALD;
        return BRAND_ROAD_SIDE_NUMBER.MY_ALD;
    }
  }
}
